export default __webpack_public_path__ + "static/media/Kanch_Mandir_Indore.e3213694.jpg";